<template>
  <button
    @click="fetchAggregator"
    type="button"
    :class="[from === 'nav' ? 'tw-relative tw-whitespace-nowrap tw-py-2 tw-px-3 tw-flex tw-items-center tw-bg-gray-200 tw-text-gray-700 tw-font-semibold tw-text-sm tw-rounded-lg hover:tw-bg-gray-300 focus:tw-ring focus:tw-ring-gray-300': 'md:tw-text-left focus:[outline-style:auto] focus:tw-outline-auto focus:tw-outline-2 focus:tw-outline-primary-700']"
  >
    <span v-if="from === 'nav'" class="material-symbols-outlined tw-mr-1.5">redeem</span>
    <span>{{ localize("giftCards") }}</span>
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";
import axios from "axios";
import { API_ROUTES } from "lib/workperks/common/constants";
import { SweetAlertTailwind as Swal } from "lib/SwalExtension";
import analyticsService from "lib/workperks/services/AnalyticsService";
import { TrackingAction } from "lib/workperks/models/Analytics";

const props = withDefaults(defineProps<{
  from?: 'nav' | 'footer';
}>(), {
  from: 'nav',
});

const dictionary = {
  en: {
    loading: "Loading",
    errorTitle: "Oops..something went wrong.",
    errorText: "Please try again later.",
    new: "New",
    giftCards: "eGift Cards",
  },
  fr: {
    loading: "Chargement",
    errorTitle: "Oups... quelque chose s'est mal passé.",
    errorText: "Veuillez réessayer plus tard.",
    new: "Nouveau",
    giftCards: "Cartes-cadeaux numériques",
  },
};

const localize = (key: string) => {
  const lang = window.l.locale || "en";
  return dictionary[lang]?.[key] || dictionary.en[key];
};

const fetchAggregator = async () => {
  if (analyticsService.isInitialized) {
    analyticsService
      .setTemplateId(null)
      .trackGiftCardButton(TrackingAction.Click);
  }

  const cancelTokenSource = axios.CancelToken.source();

  try {
    Swal.fire({
      title: localize("loading"),
      icon: "info",
      allowOutsideClick: true,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
      willClose: () => {
        // Cancel the request if modal is closed
        cancelTokenSource.cancel("Request cancelled by user.");
      },
    });

    const response = await axios.get(
      `${API_ROUTES.venngoApi}/workperks/aggregator/url/locale/${window.l.locale}/retrieve`,
      {
        headers: {
          "x-api-token": window.s.apiToken,
        },
        cancelToken: cancelTokenSource.token,
      }
    );

    if (response.data.data && response.data.data.redirectUrl) {
      Swal.close();
      window.open(response.data.data.redirectUrl, "_blank", "noopener,noreferrer");
    } else {
      Swal.close();
      setTimeout(() => {
        Swal.fire({
          title: localize("errorTitle"),
          icon: "error",
          text: localize("errorText"),
        });
      }, 100);
    }
  } catch (error) {
    if (axios.isCancel && axios.isCancel(error)) {
      console.warn("Request cancelled by user.");
    } else {
      Swal.close();
      setTimeout(() => {
        Swal.fire({
          title: localize("errorTitle"),
          icon: "error",
          text: localize("errorText"),
        });
      }, 100);
    }
  }
};

defineExpose({
  localize,
  fetchAggregator,
});
</script>
